'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var MenuItem = _interopDefault(require('@material-ui/core/MenuItem'));
var styledComponents = require('../styled-components.js');

var RangeSelector = function (_a) {
    var rangeChoice = _a.rangeChoice, handleChange = _a.handleChange;
    var intl = reactIntl.useIntl();
    var fm = intl.formatMessage;
    var Translations = {
        months: fm({ id: 'componentLib.appWide.months' }),
        years: fm({ id: 'componentLib.appWide.years' }),
        custom: fm({ id: 'componentLib.appWide.custom' }),
    };
    var items = [
        {
            value: 3,
            amount: 3,
            interval: Translations.months,
        },
        {
            value: 6,
            amount: 6,
            interval: Translations.months,
        },
        {
            value: 12,
            amount: 12,
            interval: Translations.months,
        },
        {
            value: 24,
            amount: 2,
            interval: Translations.years,
        },
    ];
    return (React__default.createElement(styledComponents.StyledRangeSelector, { value: rangeChoice, onChange: handleChange, input: React__default.createElement(styledComponents.StyledInput, null), inputProps: { 'data-testid': 'range-select' } },
        items.map(function (_a) {
            var value = _a.value, amount = _a.amount, interval = _a.interval;
            return (React__default.createElement(MenuItem, { key: value, value: "" + value },
                React__default.createElement(styledComponents.StyledRangeSelectorText, null, fm({ id: 'componentLib.monthYearRangePicker.last' }, { amount: amount, interval: interval }))));
        }),
        React__default.createElement(MenuItem, { value: 'custom' },
            React__default.createElement(styledComponents.StyledRangeSelectorText, null, Translations.custom))));
};

module.exports = RangeSelector;
